document.addEventListener('alpine:init', () => {
  var klaviyo = window.klaviyo || [];

  Alpine.store("cart", {
    data: {
      item_count: 0
    },
    beforeAjax() {
      Alpine.store("ajaxWorking", true);
    },
    afterAjax(add = false) {
      Alpine.store("ajaxWorking", false);
      if (!document.body.classList.contains("template--cart")) {
        Alpine.store("cartOpen", true);
      }
      this.getCartData(add);
    },
    getCartData(add = false) {
      fetch("/cart.js")
        .then((res) => res.json())
        .then((json) => {
          this.data = {
            ...json,
            quantity: json.items.filter(i => i.variant_title != '1 Pack').reduce((a, b) => a + b.quantity, 0)
          };

          //Klaviyo tracking
          if (add) {
            klaviyo.push([
              "track",
              "Added to Cart",
              {
                total_price: this.data.total_price / 100,
                $value: this.data.total_price / 100,
                total_discount: this.data.total_discount,
                original_total_price: this.data.original_total_price / 100,
                items: this.data.items,
              },
            ]);
          }
        });
    },
    clear() {
      this.beforeAjax();
      fetch("/cart/clear.js", {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
      }).then((response) => {
        if (response.ok) {
          // this.$dispatch('cart-update');
        }
        this.cartError = !response.ok;
        this.afterAjax();
      });
    },
    addCartItem(variantId, quantity = 1, properties = {}, selling_plan = false) {
      this.beforeAjax();
      fetch("/cart/add.js", {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({
          id: variantId,
          quantity: quantity,
          properties: properties,
          ...(selling_plan ? { selling_plan: selling_plan }: {})
        }),
      }).then((response) => {
        if (response.ok) {
        }
        this.cartError = !response.ok;
        this.afterAjax(true);
      });
    },
    updateCartItem(variantIdOrKey, quantity = 1) {
      const matchingCartItems = this.data.items.filter(
        (cartItem) =>
          cartItem.variant_id == variantIdOrKey ||
          cartItem.key == variantIdOrKey
      );
      const add =
        matchingCartItems.length > 0 &&
        matchingCartItems[0].quantity < quantity;
      this.beforeAjax();
      fetch("/cart/change.js", {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({
          id: variantIdOrKey,
          quantity: quantity,
        }),
      }).then((response) => {
        if (response.ok) {
        }
        this.cartError = !response.ok;
        this.afterAjax(add);
      });
    },
    removeCartItem(variantId) {
      this.updateCartItem(variantId, 0);
    },
    removeBaBCartItem(boxId) {
      let itemsToRemove = {}
      const matchingCartItems =
        this.data.items.filter(
          (cartItem) =>
            cartItem.properties._boxId == boxId
        ).map(i => {
          itemsToRemove[i.key] = 0
          return {
            key: i.key,
            quantity: 0,
          }
        });

      this.beforeAjax();
      fetch("/cart/update.js", {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({
          updates: itemsToRemove
        }),
      }).then((response) => {
        if (response.ok) {
        }
        this.cartError = !response.ok;
        this.afterAjax();
      });
    },
  });

  //Can call the update via
  window.updateAlpineCart = () =>
    document
      .querySelector('body')
      .dispatchEvent(new CustomEvent('cart-update'));

  // Alpine.start();
});
